// src/stores/locale.ts
import { defineStore } from 'pinia'

type LocaleType = 'en' | 'id';

interface LocaleState {
  currentLocale: LocaleType;
}

export const useLocaleStore = defineStore({
  id: 'locale',
  state: (): LocaleState => ({
    currentLocale: 'id'
  }),
  actions: {
    toggle() {
      this.currentLocale = this.currentLocale === 'id' ? 'en' : 'id';
    }
  },
  persist: true,
})
